import { render, staticRenderFns } from "./menuitem.vue?vue&type=template&id=4a0923dd&scoped=true&"
import script from "./menuitem.vue?vue&type=script&lang=js&"
export * from "./menuitem.vue?vue&type=script&lang=js&"
import style0 from "./menuitem.vue?vue&type=style&index=0&id=4a0923dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0923dd",
  null
  
)

export default component.exports